import { useRouter } from "next/router";
import { SvgWeb } from "../../public/images/svg/SvgWeb";
import { observer } from "mobx-react-lite";
import { useEffect } from "react";

type SearchStore = {
  searchText: string;
  setSearchText: (searchText: string) => void;
  typedSearchText: string;
  setTypedSearchText: (typedSearchText: string) => void;
};

export const Search = observer(
  ({
    className,
    id,
    store,
    onSubmit,
  }: {
    className?: string;
    store?: SearchStore;
    id: string;
    onSubmit?: () => void;
  }) => {
    const router = useRouter();

    useEffect(() => {
      if (!store) {
        return;
      }
      const handleKeyPress = (event: KeyboardEvent) => {
        const focusedElement = document.activeElement;

        if (event.key === "Enter") {
          if (focusedElement?.id === id) {
            onSubmit?.();
          } else {
            store.setSearchText(store.searchText);
          }
        }
      };

      window.addEventListener("keydown", handleKeyPress);

      return () => {
        window.removeEventListener("keydown", handleKeyPress);
      };
    }, [router, store]);

    return (
      <div className={className}>
        <div className="relative">
          <div className="pointer-events-none absolute inset-y-0 start-0 flex items-center ps-3">
            <SvgWeb
              name="magnifyingGlass"
              alt="magnifying_glass"
              width={20}
              height={20}
            />
          </div>
          <input
            id={id}
            tabIndex={-1}
            type="search"
            className="block w-full rounded-lg border-gray-300 bg-gray-200 p-3.5 ps-10 text-sm text-gray-900 focus:border-blue-500 focus:ring-blue-500"
            placeholder="Rechercher"
            value={store?.typedSearchText ?? ""}
            onChange={
              store !== undefined
                ? (e) => store.setTypedSearchText(e.target.value)
                : undefined
            }
          />
        </div>
      </div>
    );
  }
);

export default Search;
